<!--
텍스트모듈
-->
<template>
    <div class="uk-flex uk-flex-between">
        <div class="uk-width-expand uk-margin-right">
            <!-- 읽기모드 -->
            <div v-show="! isEditMode" v-nl2br="content">
            </div>

            <!-- 수정모드 -->
            <div v-show="isEditMode">
                <app-input-ex
                    type="textarea"
                    v-model="editedContent"
                    :textarea-rows="10"
                ></app-input-ex>

                <div class="uk-text-center uk-margin-top">
                    <button
                        class="uk-button uk-button-danger uk-margin-right"
                        @click="isEditMode = false"
                    >
                        <i class="material-icons">close</i>
                        취소
                    </button>

                    <button
                        class="uk-button uk-button-primary"
                        @click="save"
                    >
                        <i class="material-icons">done</i>
                        저장
                    </button>
                </div>
            </div>

        </div>


        <div class="uk-width-auto" v-show="! hideEditButton">
            <button
                class="uk-button uk-button-xsmall uk-button-white"
                title="내용수정"
                v-show="! isEditMode"
                @click="isEditMode = true"
            >
                <i class="material-icons">edit</i>
                수정
            </button>
            <button
                class="uk-button uk-button-xsmall uk-button-danger"
                title="수정취소"
                v-show="isEditMode"
                @click="isEditMode = false"
            >
                <i class="material-icons">close</i>
                취소
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * csrf token
             */
            csrfToken: {
                type: String,
                required: true,
            },

            /**
             * 컨텐츠ID
             */
            contentId: {
                type: Number,
                required: true,
            },

            /**
             * 컨텐츠
             */
            content: {
                type: String,
                default: null,
            },

            /**
             * 수정버튼 표시안함
             */
            hideEditButton: {
                type: Boolean,
                default: false,
            },
        },
        data: function () {
            return {
                /**
                 * (bool) 수정모듀여부
                 */
                isEditMode: false,

                /**
                 * (string) 수정된 내용
                 */
                editedContent: this.content,
            };
        },
        mounted: function () {
            //console.log('text 모듈 로드!');
        },
        computed: {
        },
        methods: {
            /**
             * 저장
             */
            save() {
                // ajax 옵션
                let cmp = this;
                let opts = {
                    type: 'patch',
                    url: '/board-contents/' + this.contentId,
                    data: {
                        '_token': this.csrfToken,
                        'content': this.editedContent,
                    },
                    success: (response, textStatus, jqXHR) => {
                        cmp.$emit('done', response.msg);
                    },
                };

                // ajax 실행
                $.app.ajax.module.default(opts);
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>